import {createSelector} from '@reduxjs/toolkit';

const userSelector = createSelector(
    state => state.user,
    user => user
);

const isVSTSelector = createSelector(
    [userSelector],
    user => user.company_id === 2
)

const userSelectors = {
    user: userSelector,
    isVST: isVSTSelector
};

export default userSelectors;